<template>
  <el-dialog
    :title="$t('communityRecommend.add')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <el-form 
      :model="addCommunityRecommendInfo" 
      ref="addForm" 
      label-width="120px"
      :rules="rules">
      <el-form-item 
        :label="$t('communityRecommend.logo')" 
        prop="logo">
        <upload-image-url
          ref="uploadImage"
          :callBackListener="'addCommunityRecommend'"
          :callBackFunction="'notifyUploadCoverImage'"
          :imageCount="1">
        </upload-image-url>
      </el-form-item>
      <el-form-item 
        :label="$t('communityRecommend.productName')" 
        prop="prodName">
        <el-input 
          v-model="addCommunityRecommendInfo.prodName"
          :placeholder="$t('communityRecommend.requiredProductName')">
        </el-input>
      </el-form-item>
      <el-form-item 
        :label="$t('communityRecommend.price')" 
        prop="price">
        <el-input 
          v-model="addCommunityRecommendInfo.price"
          :placeholder="$t('communityRecommend.requiredPrice')">
        </el-input>
      </el-form-item>
      <el-form-item 
        :label="$t('communityRecommend.accessUrl')" 
        prop="url">
        <el-input 
          v-model="addCommunityRecommendInfo.url"
          :placeholder="$t('communityRecommend.requiredAccessUrl')">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveCommunityRecommend">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveCommunityRecommend } from '@/api/phone/communityRecommend/communityRecommendApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'

export default {
  name: 'AddCommunityRecommend',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      dialogVisible: false,
      addCommunityRecommendInfo: {
        crId: '',
        communityName: '',
        shopName: '未知',
        shopId: '9999',
        recommendType: 'OUT',
        logo: '',
        prodName: '',
        price: '',
        url: ''
      },
      rules: {
        logo: [
          { required: true, message: this.$t('communityRecommend.logoRequired'), trigger: 'blur' }
        ],
        prodName: [
          { required: true, message: this.$t('communityRecommend.productNameRequired'), trigger: 'blur' },
          { max: 256, message: this.$t('communityRecommend.max256Chars'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('communityRecommend.priceRequired'), trigger: 'blur' },
          { max: 10, message: this.$t('communityRecommend.max10Chars'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('communityRecommend.urlRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.addCommunityRecommendInfo.shopId = params.shopId
      this.addCommunityRecommendInfo.communityName = params.communityName
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.uploadImage.clearImage()
      })
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.clearAddCommunityRecommendInfo()
    },
    async saveCommunityRecommend() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          try {
            await saveCommunityRecommend(this.addCommunityRecommendInfo)
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('保存失败:', error)
          }
        }
      })
    },
    clearAddCommunityRecommendInfo() {
      this.addCommunityRecommendInfo = {
        crId: '',
        communityName: '',
        shopName: '未知',
        shopId: '9999',
        recommendType: 'OUT',
        logo: '',
        prodName: '',
        price: '',
        url: ''
      }
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}
</style>